import React, { useState, useEffect, useCallback } from 'react';
import { getProductRender } from "../../../../redux/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import FileConstants from '../../../../FileConstants';
import { Button } from 'antd';
import ENVIRONMENT from '../../../../environments';
import { getBaseURL } from '../../../../environments/env';

// import * as CryptoJS from "crypto-js";
const google_viewer_style_fullscreen = { height: "94vh", width: "100%" };

const ProductPublicViewer = (props) => {
    const { match: { params } } = props;

    const [id, setId] = useState(params.id);
    const [type, setType] = useState(params.type);
    const [imageWidth, setImageWidth] = useState(0);
    const [imageHeight, setImageHeight] = useState(0);
    const [aspectRatio,setAspectRatio] = useState(0);
    const [isAiModel, setIsAiModel] = useState(false);
    const [, updateState] = React.useState();
    const [isPhoneDevice, setIsPhoneDevice] = useState(false);
    const [modelParams, setModelParams] = useState('');
    const [hideAR, setHideAR] = useState(false);
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const MODEL_VIEWER_KEY = 'JKQ76HB9AB4HLNH8FK4';

    const openAr = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
            window.location.href = getUSDZUrl();
        }
        else if (/android/i.test(userAgent)) {
            window.location.href = getAndroidZUrl();
        }
        else {
            window.location.href = getAndroidZUrl();
        }
    };

    const getGlbUrl = () => {
        const downloadLinks = props.productReducer.product.download_links || [];
        const glbLink = downloadLinks.find((link) => link.display_name === 'GLB');
        if (isAiModel) {
            return ENVIRONMENT.getBaseURL('aws') + `product_assets/ai_generated_glb/${props.productReducer.product.product_id}.glb`
        }
        if (glbLink) {
            return glbLink.model_url.replace(ENVIRONMENT.DEFAULT_BASE_URL, getBaseURL(props.productReducer.product.platform));
        }
        return '';
    };

    const isARSupported = async () => {
        if (navigator.userAgent.includes("Android")) {
            return navigator.xr?.isSessionSupported('immersive-ar').then((supported) => supported) ?? false;
        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            // For iOS, generally assume AR is supported if it’s iOS 12+ for AR Quick Look support
            return parseInt(navigator.appVersion.match(/OS (\d+)_/)[1], 10) >= 12;
        }
        return false;
    };

    const getAndroidZUrl = () => {
        let link = (props.productReducer.product.download_links || []).find((ele) => ele.display_name == 'GLB');

        if(isARSupported()) {
            return `intent://arvr.google.com/scene-viewer/1.0?file=${getGlbUrl()}&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;end;`;
        }
        else if (link) {
            let shortened_link = window.location.origin + '/android/' + params.id;
            return shortened_link.replace(ENVIRONMENT.DEFAULT_BASE_URL, getBaseURL(props.productReducer.product['platform']))
        } else {
            return ''
        }
    }

    const getUSDZUrl = () => {
        let link = (props.productReducer.product.download_links || []).find((ele) => ele.display_name == 'USDZ');
        if (isAiModel) {
            return getBaseURL('aws') + `product_assets/ai_generated_usdz/${props.productReducer.product.product_id}.usdz`
        }
        if (link) {
            let shortened_link = '';
            if(props.productReducer.product['platform'] == 'aws'){
                shortened_link = window.location.origin + '/usdz/' + params.id;
            }else{
                shortened_link = window.location.origin + '/usdz/g/' + params.id;
            }
            return shortened_link;
        } else {
            return ''
        }
    }

    useEffect(() => {
        
        // Need to use for future
        // var encrypted = CryptoJS.AES.encrypt(params.id, "all3d");
        // var dataString = encrypted.toString().replace(/\+/g,'p1L2u3S').replace(/\//g,'s1L2a3S4h').replace(/=/g,'e1Q2u3A4l');
        // var ciphertext = dataString.replace(/p1L2u3S/g, '+' ).replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=');
        // var decrypted = CryptoJS.AES.decrypt(ciphertext, "all3d");
        // console.log(decrypted.toString(CryptoJS.enc.Utf8))
        const search = window.location.search;
        const search_params = new URLSearchParams(search)
        const company_id = search_params.get('company_id') 
        const isAiModel = search_params.get('ai_model')

        if (isAiModel) {
            setIsAiModel(true);
        }

        if (params.username == undefined) {
            props.getProduct({ product_id: id, 'public': true });
        } else {
            let payload = {
                product_id: id,
                username: params.username
            }
            if(company_id)
                payload['company_id'] = company_id;
            props.getProduct(payload);
        }
        
    }, []);

    useEffect(() => {
        if (params.type == 'product_360') {
            resize360Spin();
        }
        if(document.getElementById('model-viewer-3d') != undefined && getGLBUrl() != ""){
            let viewer = document.getElementById('model-viewer-3d').contentWindow;
                let message = {
                    key : MODEL_VIEWER_KEY,
                    glbURL : getGLBUrl(),
                    hdri: props.productReducer.product.company_hdri
                }
            viewer.postMessage(message, "*");
        }
    }, [props]);

    React.useEffect(() => {
        if (params.type == 'product_360') {
            window.addEventListener('resize', resize360Spin); 
        }
        return () => {
            if (params.type == 'product_360') {
                window.removeEventListener('resize',  resize360Spin);
            }
        }
    });

    useEffect(() => {
        setIsPhoneDevice(checkIsPhone());
        checkIosVersion();
        
    }, []);


    useEffect(() => {
        const query = new URLSearchParams(props.location.search);
        let hide_ar = query.get('hide_ar');
        let hide_gizmo = query.get('hide_gizmo');
        if (hide_ar == 'true') {
            setHideAR(true);
        }
        const model3DParams = new URLSearchParams();
        if (hide_gizmo == 'true') model3DParams.append('hide_gizmo', hide_gizmo);
        if (model3DParams.toString()) {
            setModelParams('&' + model3DParams);
        }
    }, [props?.location?.search]);


    const checkIosVersion = () => {
        var agent = window.navigator.userAgent,
        start = agent.indexOf( "OS" );
        if( ( agent.indexOf( "iPhone" ) > -1 || agent.indexOf( "iPad") > -1 ) && start > -1 ){
            console.log(window.Number( agent.substr( start + 3, 3 ).replace( "_", ".") ))
            if (window.Number( agent.substr( start + 3, 3 ).replace( "_", ".") ) < 15) {
                alert("Your iOS version is not supported. Update to latest version to run the AR Viewer.")
            }
        }
    }
    
    const checkIsPhone = () => {
        const isMobileUA = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
        
        // const isSmallScreen = window.matchMedia("(max-width: 1100px)").matches;
        // const isLandscapeTablet = window.matchMedia("(max-height: 1024px) and (max-width: 1367px) and (orientation: landscape)").matches;
    
        return isMobileUA
    };

    const getGLBUrl = () => {
        let link = (props.productReducer.product.download_links || []).find((ele) => ele.display_name == 'GLB');
        if (isAiModel) {
            return ENVIRONMENT.getBaseURL('aws') + `product_assets/ai_generated_glb/${props.productReducer.product.product_id}.glb`
        }
        if (link) {
            return link.model_url
        } else {
            return ''
        }
    }

    const resize360Spin = () => {
        let element = document.getElementById('container-360');
        if (imageWidth == 0) {
            const img = new Image();
            img.onload = function() {
                let aspect_ratio = this.height/this.width;
                setAspectRatio(aspect_ratio);
                setImageHeight(this.height);
                setImageWidth(this.width);
                
                set360WidthStyle(element,aspect_ratio);
            }
            img.src = (props.productReducer.product['360'] && props.productReducer.product['360']["data-folder"]) + props.productReducer.product.product_id + '_Frame1.jpg';
        }
        if (imageWidth != 0) {
            set360WidthStyle(element);
        }
    }

    const set360WidthStyle = (element, aspect_ratio = null) => {
        let aspect = aspectRatio
        if (aspect_ratio != null) {
            aspect = aspect_ratio;
        }
        if (element != null) {
            element.style.visibility = "hidden";
            element.style.width = ((document.documentElement.clientHeight - 10) / aspect) + "px";
            
            element.style.visibility = "visible";
            handleViewChange('360D');
            forceUpdate();
        }
    }

    const handleViewChange = (type) => {
        if (type == '360D') {
            setTimeout(() => {
                window.CI360.destroy();
                window.CI360.init();
            }, 10);
        }
    }

    return (
        <div style={{height:"100vh", position: "relative"}}>
            {type == "product_360" ? <div id="container-360" className="container-360-spin" style={{ height: "99vh" }}>
                <div
                    className="cloudimage-360"
                    id="image-360"
                    data-folder={props.productReducer.product['360'] && props.productReducer.product['360']["data-folder"]}
                    data-filename={props.productReducer.product['360'] && props.productReducer.product['360']["data-filename"]}
                    data-amount={props.productReducer.product['360'] && props.productReducer.product['360']["data-amount"]}>

                </div>
            </div> : type == "product_3d_model" ? 
            <>
                <div className='model-viewer-public'>
                    <div className='viewer-iframe-container'> 
                        <iframe id='model-viewer-3d' className='model-inspector-frame' src={ FileConstants.ModelInspector + props.productReducer.product.product_id + modelParams}/>
                    </div>
                    {isPhoneDevice && !hideAR &&
                     <div className='view-ar-btn'>
                        <Button className="add-model-button font-12-em" onClick={openAr}>
                            <img src={'/img/ar.png'} />
                            View in AR
                        </Button>
                    </div>}
                </div>
                </>
            : '' }
        </div>
            
    );
}


const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => ({
    getProduct: (product) => {
        dispatch(getProductRender(product));
    }
});


export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductPublicViewer));